import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ListBoxComponent} from './list-box.component';

@NgModule({
    declarations: [
        ListBoxComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ListBoxComponent
    ],
    providers: []
})

export class BlitzBasicScriptListBoxModule {
}
